module.exports = __webpack_public_path__ + "img/nextdoor.4e978f07.svg";